<div class="inputCalendarWrapper">
    <input
        type="text"
        autocomplete="off"
        readonly="readonly"
        [formControl]="dateRangeControl"
        (keydown.space)="openCalendar($event)"
        (keydown.enter)="openCalendar($event)"
        (click)="openCalendar($event)"
        #dateInput
    />
    @if (dateRangeControl.value) {
        <button
            class="button small transparent dateClear"
            tabindex="0"
            (click)="clearDate()"
            (keydown.space)="clearDate()"
            (keydown.enter)="clearDate()"
        >
            <i class="far fa-times"></i>
        </button>
    }
</div>
